/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToApiResponse, convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminAllPalletOrdersResponse,
    AdminAllPalletOrdersResponseFromJSON,
    AdminAllPalletOrdersResponseToJSON,
} from '../models';

export function createAdminGetAllPalletsPath(): string {
    return `/admin/pallet_orders`;
}
export function createAdminGetAllPalletsFullPath(): string {
    return runtime.BASE_PATH + `/admin/pallet_orders`;
}

/**
 *
 */
export class AdminGetAllPalletsApi extends runtime.BaseAPI {
    /**
     * Get all pallet orders
     * Get all pallet orders
     */
    async adminGetAllPallets(
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminAllPalletOrdersResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminGetAllPalletsPath(),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminAllPalletOrdersResponseFromJSON(jsonValue))
        );
    }
}
